module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--intersport-f7aed96bed6042e38387b48fb883814c.jpg";